
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ebook/[slug]",
      function () {
        return require("private-next-pages/ebook/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ebook/[slug]"])
      });
    }
  